import React from 'react';

/** @internal */
export var removeCircleIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 9.4054L13.1313 6.27405C13.3207 6.08471 13.6072 6.06424 13.7713 6.22834C13.9354 6.39244 13.9149 6.67896 13.7256 6.86831L10.5943 9.99965L13.7254 13.1308C13.9148 13.3202 13.9353 13.6067 13.7712 13.7708C13.6071 13.9349 13.3205 13.9144 13.1312 13.7251L10 10.5939L6.86881 13.7251C6.67946 13.9144 6.39294 13.9349 6.22884 13.7708C6.06474 13.6067 6.08521 13.3202 6.27455 13.1308L9.40574 9.99965L6.2744 6.86831C6.08506 6.67896 6.06459 6.39244 6.22869 6.22834C6.39279 6.06424 6.67931 6.08471 6.86866 6.27405L10 9.4054Z",
  fill: "white"
}));